module.exports = __webpack_public_path__ + "media/images/step-recource-4b169f84.png";